import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import BookingSteps, { STEPS_TYPE } from '@/organisms/booking-steps';
import MeetingRoomLanding from '@/organisms/meeting-room-landing';
import RedirectToHome from '@/organisms/redirect-to-home';
import { useLocationsStore } from '@core/locations/store/locations';
import { useSettingsStore } from '@core/settings/store/settings';

const BookingMeetingRoomPage = () => {
  const { t } = useTranslation();
  const { isMeetingRoomEnabled } = useSettingsStore();
  const { locations } = useLocationsStore();
  const router = useRouter();
  const { clientName, locationId, roomId, date, startTime, endTime } = router.query;

  useEffect(() => {
    if (!isMeetingRoomEnabled) {
      router.push(`/home?clientName=${clientName}`);
    }
  }, []);

  const handleBackToLanding = useCallback(() => {
    router.push(`/booking/meeting-room?clientName=${clientName}`);
  }, [router, clientName]);

  if (!isMeetingRoomEnabled) return <RedirectToHome message={t('booking.notAllowedMeetingRoom')} />;

  if (locationId) {
    return (
      <BookingSteps
        stepsType={STEPS_TYPE.MEETING_ROOM}
        locations={locations}
        preSelectedLocationId={locationId as string}
        preSelectedRoomId={roomId as string}
        preSelectedDate={date as string}
        preSelectedStartTime={startTime as string}
        preSelectedEndTime={endTime as string}
        onBackToLanding={handleBackToLanding}
      />
    );
  }

  return <MeetingRoomLanding />;
};

export default BookingMeetingRoomPage;
